"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablBody = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const lib_1 = require("../../lib");
const TablContext_1 = require("./TablContext");
const CONTEXT_VALUE = { variant: 'body' };
const TablBody = (_a) => {
    var { children, className } = _a, rest = (0, tslib_1.__rest)(_a, ["children", "className"]);
    return ((0, jsx_runtime_1.jsx)(TablContext_1.TablContext.Provider, Object.assign({ value: CONTEXT_VALUE }, { children: (0, jsx_runtime_1.jsx)("tbody", Object.assign({}, rest, { className: (0, lib_1.classnames)('tabl__body', className) }, { children: children }), void 0) }), void 0));
};
exports.TablBody = TablBody;
//# sourceMappingURL=TablBody.js.map